import { useState } from "react";
import { RemoveVoid } from "../../../../../../common/common_utils";
import { Constants } from "../../../../../../common/constants";
import { RouterInferenceHelpers } from "../../../../../../src/api/trpc/rootRouter";
import { SeshPrimaryButton } from "../base_components/sesh_primary_button";
import { SeshTextInput } from "../base_components/sesh_text_input";
import { useServerId } from "../hooks/use_server_id";
import { useSetBookmarkMutation } from "../hooks/use_setbookmark_mutation";

export function EventTemplateSaveFavoriteInput(props: {
	initial_name: string;
	is_full?: boolean;
	onSaveSuccess?: () => void;
	save_props: Omit<
		RemoveVoid<
			RouterInferenceHelpers["event_template"]["setBookmark"]["input"]
		>,
		"name" | "guild_id"
	>;
	label: "Save" | "Favorite";
}) {
	const [name, setName] = useState(props.initial_name);
	const server_id = useServerId();

	const mutation = useSetBookmarkMutation(props.onSaveSuccess);

	const is_name_empty = name.length <= 0;
	const is_name_too_long =
		name.length > Constants.EVENT_TEMPLATE_NAME_LIMITS.max;

	return (
		<form
			className="flex flex-col gap-2"
			onSubmit={(e) => {
				e.stopPropagation();
				e.preventDefault();
				mutation.mutate({
					...props.save_props,
					guild_id: server_id,
					name: name,
				});
			}}
		>
			<SeshTextInput
				input_props={{
					placeholder: "Template name",
					value: name,
					onChange: (e) => {
						setName(e.currentTarget.value);
					},
					type: "submit",
					autoFocus: true,
				}}
				error_text={
					is_name_empty
						? "can not be empty"
						: is_name_too_long
						? "character limit reached"
						: undefined
				}
			/>
			<div className="ml-auto w-fit">
				<SeshPrimaryButton
					className="flex items-center gap-2"
					disabled={
						is_name_empty || is_name_too_long || props.is_full
					}
					is_loading={mutation.isLoading}
					type="submit"
				>
					<i className="fas fa-star"></i>
					<div>{props.is_full ? "Favorites Full" : props.label}</div>
				</SeshPrimaryButton>
			</div>
		</form>
	);
}
